import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Confirm } from 'src/app/utils/models';
import { ConfirmComponent } from './confirm.component';

@Injectable()
export class ConfirmService {
  constructor(private readonly dialog: MatDialog) {}
  open(data: Confirm): MatDialogRef<ConfirmComponent, boolean> {
    return this.dialog.open<ConfirmComponent, Confirm>(ConfirmComponent, {
      data,
    });
  }
}
